export default vm => {
    return vm.profile.customerId
        ? vm.$riDataProvider
            .get('permissions')
            .then(({ permissions }) => permissions)
            .catch(() => [])
        : Promise.resolve([]);
};
